module.exports = __webpack_public_path__ + "static/iPhone@2x-58a765d1bfe8309a17bac2f6ed432b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/prototyping/iPhone@2x.png
// module id = 2612
// module chunks = 168707334958949